/* file description */
import React, { FC, useState, useEffect } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import useValuesStore from '@/store/useValuesStore';
import { ReferenceRenderProps } from './type';
import _ from 'lodash';
import { Popover } from 'antd';
import { COLUMN_FROM } from '../../effects/consts';

const LinkRender: FC<ReferenceRenderProps> = ({
  field,
  API,
  rowsData,
  columnFrom,
  targerValue,
  store,
  setViewValue,
}) => {
  const { name, linkBy, linkByFieldName, linkByLabel, showModule, showNamespace = 'master_data', showModuleLabel, showModuleValue, isImg } = field;
  const { dataKey, treeId, label, value } = field?.linkByField?.bizConfig || {};
  const [renderData, setRenderData] = useState<any>('');

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  const getShowFieldLabel = async (initVal: string) => {
    const res = await getModuleRecordListCache(
      API?.FetchAPI,
      showNamespace,
      showModule,
      {
        moduleID: showModule,
        namespaceID: showNamespace,
        limit: 100,
        filter: `${showModuleValue} = '${initVal}'`,
      },
    );
    const recordValues = res.set?.[0]?.values || [];
    const resultLabel = recordValues.find((json: any) => json.name === showModuleLabel)?.value || initVal;
    return resultLabel;
  };

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    const fieldDataList: any[] = [];
    if (columnFrom === COLUMN_FROM.TABLE) {
      rowsData?.forEach((item: any) => {
        if (item[linkBy]) {
          fieldDataList.push(item[linkBy]);
        }
      });
    } else {
      fieldDataList.push(targerValue);
    }
    if (fieldDataList.length < 1) {
      return;
    }
    const targetSql = fieldDataList.map((fV) => `'${fV}'`).join(',');
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      limit: 3000,
      filter: `${value} in (${targetSql})`,
    };
    getModuleRecordListCache(API?.FetchAPI, params.namespaceID, params.moduleID, params).then((res: any) => {
      const { set = [] } = res || {};
      const listData = set.map((r: any) => convert(r));
      const findDictItem = listData?.find(
        (item: any) => item[linkByFieldName] === targerValue,
      );
      if (showModule && showModuleLabel && showModuleValue && findDictItem?.[name]) {
        getShowFieldLabel(findDictItem?.[name]).then((resultData: string) => {
          setRenderData(resultData);
        });
      } else {
        setRenderData(findDictItem?.[name] || '');
      }
      // form中把联动展示字段值塞入store
      if (columnFrom === COLUMN_FROM.FORM && store?.setValuesImmediate) {
        const newValues: Record<any, any> = {};
        newValues[`${linkBy}_LINK_${name}`] = findDictItem?.[name] || '';
        store.setValuesImmediate((storeValues: any) => {
          Object.keys(storeValues).forEach((key: any) => {
            if (!Array.isArray(storeValues[key])) {
              Object.assign(storeValues, { [key]: { ...storeValues[key], ...newValues } });
            }
          });
          return storeValues;
        });
      }
    });
  }, [targerValue]);
  //  }, [rowsData, targerValue, store?.values]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  const picElement = (type: string) => {
    return (
      <div>
        <img style={{ width: type === 'init' ? '60px' : '500px' }} src={renderData} />
      </div>
    );
  };

  if (isImg && renderData) {
    return (
      <div style={{ height: '32px', overflow: 'hidden' }}>
        <Popover content={picElement('preview')} title="预览" trigger="click">
          {picElement('init')}
        </Popover>
      </div>
    );
  } else {
    return renderData;
  }
};
export default LinkRender;
